import StatCard from '@/components/base/StatCard';
import { platformStats } from '@/mocks/home';

export default function PlatformStats() {
  return (
    <section className="py-16 md:py-24">
      <div className="max-w-[1440px] mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-center">
          <div className="lg:col-span-7">
            <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-900 leading-tight">
              韩漫爱好者的
              <br />
              首选平台
            </h2>
            <p className="mt-2 text-sm text-foreground-500">用数据说话，值得信赖的韩漫阅读平台</p>
            <div className="mt-10 grid grid-cols-3 gap-6 md:gap-8 border-t border-background-200 pt-8">
              {platformStats.map((stat) => (
                <StatCard key={stat.label} {...stat} />
              ))}
            </div>
          </div>

          <div className="lg:col-span-5">
            <div className="relative h-72 md:h-80 rounded-3xl overflow-hidden bg-primary-100/60">
              <div className="absolute inset-0 flex items-center justify-center">
                <div className="relative w-full h-full">
                  <div className="absolute top-8 left-8 w-32 h-32 rounded-3xl bg-primary-200/60 rotate-12"></div>
                  <div className="absolute top-16 right-8 w-24 h-24 rounded-2xl bg-accent-200/60 -rotate-6"></div>
                  <div className="absolute bottom-8 left-12 w-28 h-28 rounded-full bg-primary-300/40"></div>
                  <div className="absolute bottom-12 right-12 w-36 h-36 rounded-3xl bg-primary-100/80 rotate-45"></div>
                  <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-20 h-20 rounded-2xl bg-accent-300/50 rotate-12"></div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}